import { BiMapAlt, BiPackage, BiPlus } from 'react-icons/bi';

import type { ProductActionsDefinition } from '@hopdrive/feature-portal-products';

import ManualOrderEntryDialog from './components/ManualOrderEntryDialog';
import RouteTemplateBuilderDialog from './components/RouteTemplateBuilderDialog';

/**
 * Parts Delivery's header actions: one "New" menu with the two ways to create work, each a dialog
 * the layout mounts at product level so it opens from every tab. No presence conditions; the
 * layout gates both on the entry's `canCreate`.
 */
export const PARTS_DELIVERY_ACTIONS: ProductActionsDefinition = {
  menuLabel: 'New',
  menuIcon: <BiPlus />,
  createUnavailableText: 'Creating orders and templates is unavailable for this rooftop',
  // Priority order: the landing tab's CTA first.
  creation: [
    {
      key: 'order',
      label: 'Order',
      icon: <BiPackage />,
      dialog: ({ open, onClose, onCreated }) => (
        <ManualOrderEntryDialog open={open} onClose={onClose} onSuccess={onCreated} />
      ),
    },
    {
      key: 'template',
      label: 'Template',
      icon: <BiMapAlt />,
      dialog: ({ open, onClose, onCreated }) => (
        <RouteTemplateBuilderDialog open={open} onClose={onClose} onSaved={onCreated} />
      ),
    },
  ],
};

/** Parts Delivery's actions take no facts; the definition is one shared object. */
export function resolvePartsDeliveryActions(): ProductActionsDefinition {
  return PARTS_DELIVERY_ACTIONS;
}
